import { render, staticRenderFns } from "./StockRoute.vue?vue&type=template&id=2d284ba6"
import script from "./StockRoute.vue?vue&type=script&lang=ts"
export * from "./StockRoute.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d284ba6')) {
      api.createRecord('2d284ba6', component.options)
    } else {
      api.reload('2d284ba6', component.options)
    }
    module.hot.accept("./StockRoute.vue?vue&type=template&id=2d284ba6", function () {
      api.rerender('2d284ba6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/stock/StockRoute.vue"
export default component.exports